/**
 * Get storage key for widget thread ID
 */
function getStorageKey(widgetId: string): string {
  return `tktid-${widgetId}`;
}

/**
 * Get thread ID from localStorage
 */
export function getStoredThreadId(widgetId: string): string | null {
  const key = getStorageKey(widgetId);

  // Try localStorage
  try {
    const stored = localStorage.getItem(key);
    if (stored) {
      return stored;
    }
  } catch (e) {
    // localStorage might be unavailable
  }

  return null;
}

/**
 * Store thread ID in localStorage
 */
export function storeThreadId(widgetId: string, threadId: string): void {
  const key = getStorageKey(widgetId);

  // Try localStorage
  try {
    localStorage.setItem(key, threadId);
  } catch (e) {
    // localStorage might be unavailable
  }
}

/**
 * Clear thread ID from localStorage
 */
export function clearStoredThreadId(widgetId: string): void {
  const key = getStorageKey(widgetId);

  // Clear localStorage
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // localStorage might be unavailable
  }
}
